const STORAGE_KEY = 'myMessageSession';

export const saveToLocal = (data) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
};

export const getFromLocal = () => {
  const value = localStorage.getItem(STORAGE_KEY);
  return value ? JSON.parse(value) : {};
};

export const clearFromLocal = () => {
  localStorage.removeItem(STORAGE_KEY);
};
